import script from "./bonus-engine.vue?vue&type=script&setup=true&lang=js"
export * from "./bonus-engine.vue?vue&type=script&setup=true&lang=js"

import "./bonus-engine.vue?vue&type=style&index=0&id=84751992&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84751992"]])

export default __exports__